const academics = [
  {
    id: 1,
    degree: "Bachelor of Technology",
    institute: "University of Calicut",
    duration: "August 2014 - June 2018",
    description:
      "Completed Bachelor of Technology in Computer Science and Engineering from N.S.S. College of Engineering, Palakkad, Kerala, affliated under the University of Calicut.",
    iconClass: "education",
    modalContent: {
      leftContent: {
        title: "Graduation",
        description: (
          <p>
            Completed Bachelor of Technology in Computer Science and Engineering
            from N.S.S. College of Engineering, Palakkad, Kerala, affliated
            under the University of Calicut; 2014-2018.
            <br />
            <br />
            <strong>Final Year Project:</strong>{" "}
            <span className="project-title">
              Temporal and Aspect-based Opinion Summarization
            </span>
            <br />A tool that employs Machine Learning and Natural Language
            Processing to generate decision oriented insights that summarise the
            opinions of users of a device over time on the basis of its
            different aspects.
            <br />
            <strong>Programming Language:</strong> Python
          </p>
        ),
      },
      rightContent: {
        title: "Accomplishments",
        description: (
          <ul>
            <li>
              Won Best Project Award 2017-18 awarded by Tata Consultancy
              Services Ltd. for the best final year project among all
              departments.
            </li>
            <li>
              Led the team at Smart India Hackathon 2017 Grand Finale, conducted
              by the Ministry of Human Resources and Development, Goverment of
              India, at Manipal Institute of Technology, Karnataka.
            </li>
            <li>
              Only person from college to qualify CodeVita Season 6 global
              coding contest conducted by Tata Consultancy Services Ltd., 2017.
            </li>
          </ul>
        ),
      },
    },
  },
  {
    id: 2,
    degree: "High School",
    institute: "St. Raphael's Cathedral Senior Secondary School",
    duration: "June 2004 - May 2014",
    description:
      "Completed Elementary and High School education from St. Raphael's Cathedral Senior Secondary School, Palakkad, Kerala, affliated under the Central Board of Secondary Education.",
    iconClass: "education",
    modalContent: {
      leftContent: {
        title: "High School",
        description: (
          <p>
            Completed Elementary and High School education from St. Raphael's
            Cathedral Senior Secondary School, Palakkad, Kerala, affliated under
            the Central Board of Secondary Education; 2014 pass-out.
            <br />
            <br />
            <strong>Final Year Project:</strong>{" "}
            <span className="project-title">Quiz Application</span>
            <br />
            Development of a basic application which conducts a quiz competition
            by providing a random set of questions to the user and saves the
            high score data onto files for later comparison of user's
            performance.
            <br />
            <strong>Programming Language:</strong> C++
          </p>
        ),
      },
      rightContent: {
        title: "Achievements",
        description: (
          <ul>
            <li>
              Passed out as School topper in both 10th and 12th board exams
              conducted by the Central Board of Secondary Education(2011-12 and
              2013-14).
            </li>
            <li>
              Received the Best Outgoing Student award for consistent and
              outstanding academic performance throughout the years(2013-14).
            </li>
            <li>
              Inducted into the School Roll of Honour for outstanding
              performance in curricular and non-curricular activities(2013-14).
            </li>
          </ul>
        ),
      },
    },
  },
];

export default academics;
